
const remember = (memory, key, getValue = () => key) => {

    if (memory instanceof Map) {

        const remembered = memory.get(key);

        if (remembered !== undefined) return remembered;

        else {

            const value = getValue();

            memory.set(key, value);

            return value;
        }
    }

    else if (typeof memory === 'object') {

        const remembered = memory[key];

        if (memory.hasOwnProperty(`${key}`)) return remembered;

        else return memory[key] = getValue();

    }

    else throw new Error(`Cannot use remember() with non-object memory, received: ${memory}`);
}

export default remember;